import { MouseEventHandler } from "react"

import "./Error.scss"

type ErrorFallbackProps = {
  error: Error
  resetErrorBoundary: MouseEventHandler
}

export function ErrorPage({ error, resetErrorBoundary }: ErrorFallbackProps) {
  return (
    <div>
      <main>
        <div className="error-message">
          <h2 className="error-header">404</h2>
          <p>Sometimes getting lost isn't that bad...</p>
          <button className="error-button" onClick={() => window.location.replace("/click-and-sell")}>
            Back to homepage
          </button>
        </div>
      </main>
    </div>
  )
}

export function ErrorLog(error: Error, info: { componentStack: string }) {
  // We can log all our errors here
}
